const shopifyThemesSliderImagePath = "/shopify-themes/images/"
const shopifyThemesSliderCurrency = "USD"

const shopifyThemesSliderLabels = [
  "EU translations (EN, FR, IT, DE, ES)",
  "Store locator",
  "Event calendar",
  "Age verifier",
  "Countdown times",
]

const shopifyThemesImpressionSliderLabels = [
  "EU translations (EN, FR, IT, DE, ES)",
  "Cross-selling",
  "Mega menu",
  "Size chart",
  "Pre-order",
]

const shopifyThemesMetaTitle =
  "Premium Shopify Themes and Templates To Grow Your Business"
const shopifyThemesMetaDescription =
  "Find the Perfect Look for Your Online Shop with Our Premium Shopify Themes and Templates."

export const shopifyThemesMetaContent = {
  title: shopifyThemesMetaTitle,
  description: shopifyThemesMetaDescription,
  appendPostfixToTitle: false,
  meta: [
    {
      name: "title",
      content: shopifyThemesMetaTitle,
    },
    {
      name: "twitter:title",
      content: shopifyThemesMetaTitle,
    },
    {
      name: "twitter:description",
      content: shopifyThemesMetaDescription,
    },
    {
      name: "twitter:card",
      content: "summary",
    },
  ],
}

const createShopifyThemesSliderButton = ({ text, href, id }) => ({
  text,
  href,
  target: "_blank",
  ...(id ? { id } : {}),
})

const createShopifyThemesSliderImage = ({ name, alt, href }) => ({
  href,
  src: `${shopifyThemesSliderImagePath}${name}-1x.webp`,
  srcSet: `${shopifyThemesSliderImagePath}${name}-1x.webp 1x, ${shopifyThemesSliderImagePath}${name}-2x.webp 2x`,
  alt,
})

const createShopifyThemesSliderPreset = ({
  id,
  title,
  imageName,
  imageAlt,
  url,
  regularPrice,
  comparedPrice,
  swatch,
  badge,
  readMoreUrl,
  startTrialId,
}) => ({
  id,
  title,
  url,
  image: createShopifyThemesSliderImage({
    name: imageName,
    alt: imageAlt,
    href: url,
  }),
  regularPrice,
  regularCurrency: shopifyThemesSliderCurrency,
  ...(comparedPrice
    ? {
        comparedPrice,
        comparedCurrency: shopifyThemesSliderCurrency,
      }
    : {}),
  swatchClass: `themes-slider__card-swatch--${swatch}`,
  ...(badge ? { badge } : {}),
  ...(readMoreUrl
    ? {
        readMore: createShopifyThemesSliderButton({
          text: "Read more",
          href: readMoreUrl,
        }),
      }
    : {}),
  startTrial: createShopifyThemesSliderButton({
    text: "Start free trial",
    href: url,
    id: startTrialId,
  }),
})

export const shopifyThemesHeaderContent = {
  logo: {
    href: "https://themes.shopify.com/themes?q=UTD",
    target: "_blank",
    text: "Themes",
    accentText: "by UTD",
  },
}

export const shopifyThemesTextSectionContent = {
  title: "Best Shopify Themes To Grow Your Business",
  text:
    "Launch your online store effortlessly! Boost sales and engage customers with our customizable, user-friendly, innovative, and eye-catching Shopify themes. Enjoy modern, fast, SEO & ADA compliant designs with an unlimited trial period!",
  buttonText: "Start Free Today",
  buttonUrl: "#themes-slider",
}

export const shopifyThemesSliderContent = {
  id: "themes-slider",
  heading: "Standout Themes for Your Shopify Store",
  labels: shopifyThemesSliderLabels,
  cards: [
    {
      theme: "Impression",
      defaultPresetId: "impression",
      labels: shopifyThemesImpressionSliderLabels,
      readMore: createShopifyThemesSliderButton({
        text: "Read more",
        href: "https://utdweb.team/shopify-themes/impression/",
      }),
      presets: [
        createShopifyThemesSliderPreset({
          id: "impression",
          title: "Impression",
          imageName: "themes-slider-imp-imp",
          imageAlt: "Impression Impression",
          url: "https://themes.shopify.com/themes/impression/presets/impression",
          regularPrice: "$340",
          swatch: "impression",
          badge: "NEW",
          startTrialId: "Impression",
        }),
        createShopifyThemesSliderPreset({
          id: "etoile",
          title: "Etoile",
          imageName: "themes-slider-imp-etoile",
          imageAlt: "Impression Etoile",
          url: "https://themes.shopify.com/themes/impression/presets/etoile",
          regularPrice: "$340",
          swatch: "etoile",
          badge: "NEW",
          startTrialId: "Etoile",
        }),
        createShopifyThemesSliderPreset({
          id: "reflex",
          title: "Reflex",
          imageName: "themes-slider-imp-reflex",
          imageAlt: "Impression Reflex",
          url: "https://themes.shopify.com/themes/impression/presets/reflex",
          regularPrice: "$340",
          swatch: "reflex",
          badge: "NEW",
          startTrialId: "Reflex",
        }),
        createShopifyThemesSliderPreset({
          id: "mimi",
          title: "Mimi",
          imageName: "themes-slider-imp-mimi",
          imageAlt: "Impression Mimi",
          url: "https://themes.shopify.com/themes/impression/presets/mimi",
          regularPrice: "$340",
          swatch: "mimi",
          badge: "NEW",
          startTrialId: "Mimi",
        }),
        createShopifyThemesSliderPreset({
          id: "felix",
          title: "Felix",
          imageName: "themes-slider-imp-felix",
          imageAlt: "Impression Felix",
          url: "https://themes.shopify.com/themes/impression/presets/felix",
          regularPrice: "$340",
          swatch: "felix",
          badge: "NEW",
          startTrialId: "Felix",
        }),
      ],
    },
    {
      theme: "Victory",
      defaultPresetId: "victory",
      presets: [
        createShopifyThemesSliderPreset({
          id: "victory",
          title: "Victory",
          imageName: "themes-slider-victory-victory",
          imageAlt: "Victory Victory",
          url: "https://themes.shopify.com/themes/victory/presets/victory",
          regularPrice: "$320",
          swatch: "victory",
          readMoreUrl: "https://utdweb.team/shopify-themes/victory",
          startTrialId: "Victory",
        }),
        createShopifyThemesSliderPreset({
          id: "flip",
          title: "Flip",
          imageName: "themes-slider-victory-flip",
          imageAlt: "Victory Flip",
          url: "https://themes.shopify.com/themes/victory/presets/flip",
          regularPrice: "$320",
          swatch: "flip",
          readMoreUrl: "https://utdweb.team/shopify-themes/victory",
          startTrialId: "Flip",
        }),
        createShopifyThemesSliderPreset({
          id: "roast",
          title: "Roast",
          imageName: "themes-slider-victory-roast",
          imageAlt: "Victory Roast",
          url: "https://themes.shopify.com/themes/victory/presets/roast",
          regularPrice: "$320",
          swatch: "roast",
          readMoreUrl: "https://utdweb.team/shopify-themes/victory",
          startTrialId: "Roast",
        }),
        createShopifyThemesSliderPreset({
          id: "athletica",
          title: "Athletica",
          imageName: "themes-slider-victory-athletica",
          imageAlt: "Victory Athletica",
          url: "https://themes.shopify.com/themes/victory/presets/athletica",
          regularPrice: "$320",
          swatch: "athletica",
          readMoreUrl: "https://utdweb.team/shopify-themes/victory",
          startTrialId: "Athletica",
        }),
        createShopifyThemesSliderPreset({
          id: "nitro",
          title: "Nitro",
          imageName: "themes-slider-victory-nitro",
          imageAlt: "Victory Nitro",
          url: "https://themes.shopify.com/themes/victory/presets/nitro",
          regularPrice: "$320",
          swatch: "nitro",
          readMoreUrl: "https://utdweb.team/shopify-themes/victory",
          startTrialId: "Nitro",
        }),
      ],
    },
    {
      theme: "Boutique",
      defaultPresetId: "boutique-yakush",
      readMore: createShopifyThemesSliderButton({
        text: "Read more",
        href: "https://utdweb.team/shopify-themes/boutique/",
      }),
      presets: [
        createShopifyThemesSliderPreset({
          id: "boutique-yakush",
          title: "Reflections",
          imageName: "themes-slider-boutique-yakush",
          imageAlt: "Boutique Yakush",
          url: "https://themes.shopify.com/themes/boutique/presets/reflections",
          regularPrice: "$160",
          comparedPrice: "$340",
          swatch: "boutique-yakush",
          startTrialId: "BoutiqueYakush",
        }),
        createShopifyThemesSliderPreset({
          id: "boutique-boutique",
          title: "Boutique",
          imageName: "themes-slider-boutique-boutique",
          imageAlt: "Boutique Boutique",
          url: "https://themes.shopify.com/themes/boutique/presets/boutique",
          regularPrice: "$160",
          comparedPrice: "$340",
          swatch: "boutique-boutique",
          startTrialId: "BoutiqueBoutique",
        }),
        createShopifyThemesSliderPreset({
          id: "boutique-noom",
          title: "Noom",
          imageName: "themes-slider-boutique-noom",
          imageAlt: "Boutique Noom",
          url: "https://themes.shopify.com/themes/boutique/presets/noom",
          regularPrice: "$160",
          comparedPrice: "$340",
          swatch: "boutique-noom",
          startTrialId: "BoutiqueNoom",
        }),
        createShopifyThemesSliderPreset({
          id: "boutique-sayeah",
          title: "Jade",
          imageName: "themes-slider-boutique-sayeah",
          imageAlt: "Boutique Sayeah",
          url: "https://themes.shopify.com/themes/boutique/presets/jade",
          regularPrice: "$160",
          comparedPrice: "$340",
          swatch: "boutique-sayeah",
          startTrialId: "BoutiqueSayeah",
        }),
        createShopifyThemesSliderPreset({
          id: "boutique-teall",
          title: "Aurum",
          imageName: "themes-slider-boutique-teall",
          imageAlt: "Boutique Teall",
          url: "https://themes.shopify.com/themes/boutique/presets/aurum",
          regularPrice: "$160",
          comparedPrice: "$340",
          swatch: "boutique-teall",
          startTrialId: "BoutiqueTeall",
        }),
      ],
    },
    {
      theme: "Ultra",
      defaultPresetId: "ultra-tech",
      readMore: createShopifyThemesSliderButton({
        text: "Read more",
        href: "https://utdweb.team/shopify-themes/ultra-theme/",
      }),
      presets: [
        createShopifyThemesSliderPreset({
          id: "ultra-tech",
          title: "Ultra",
          imageName: "themes-slider-ultra-tech",
          imageAlt: "Ultra Tech",
          url: "https://themes.shopify.com/themes/ultra/presets/ultra",
          regularPrice: "$100",
          comparedPrice: "$360",
          swatch: "ultra-tech",
          startTrialId: "UltraTech",
        }),
        createShopifyThemesSliderPreset({
          id: "ultra-furniture",
          title: "Harbor",
          imageName: "themes-slider-ultra-furniture",
          imageAlt: "Ultra furniture",
          url: "https://themes.shopify.com/themes/ultra/presets/harbor",
          regularPrice: "$100",
          comparedPrice: "$360",
          swatch: "ultra-furniture",
          startTrialId: "UltraFurniture",
        }),
        createShopifyThemesSliderPreset({
          id: "ultra-auto",
          title: "Grip",
          imageName: "themes-slider-ultra-auto",
          imageAlt: "Ultra Auto",
          url: "https://themes.shopify.com/themes/ultra/presets/grip",
          regularPrice: "$100",
          comparedPrice: "$360",
          swatch: "ultra-auto",
          startTrialId: "UltraAuto",
        }),
        createShopifyThemesSliderPreset({
          id: "ultra-toys",
          title: "Sprout",
          imageName: "themes-slider-ultra-toys",
          imageAlt: "Ultra toys",
          url: "https://themes.shopify.com/themes/ultra/presets/sprout",
          regularPrice: "$100",
          comparedPrice: "$360",
          swatch: "ultra-toys",
          startTrialId: "UltraToys",
        }),
        createShopifyThemesSliderPreset({
          id: "grace",
          title: "Grace",
          imageName: "themes-slider-ultra-grace",
          imageAlt: "Ultra grace",
          url: "https://themes.shopify.com/themes/ultra/presets/grace",
          regularPrice: "$100",
          comparedPrice: "$360",
          swatch: "grace",
          startTrialId: "Grace",
        }),
      ],
    },
    {
      theme: "Allure",
      defaultPresetId: "allure",
      presets: [
        createShopifyThemesSliderPreset({
          id: "allure",
          title: "Allure",
          imageName: "themes-slider-allure-allure",
          imageAlt: "Allure allure",
          url: "https://themes.shopify.com/themes/allure/presets/allure",
          regularPrice: "$100",
          swatch: "allure",
          readMoreUrl: "https://utdweb.team/shopify-themes/allure",
          startTrialId: "Allure",
        }),
        createShopifyThemesSliderPreset({
          id: "bijou",
          title: "Bijou",
          imageName: "themes-slider-allure-bijou",
          imageAlt: "Allure Bijou",
          url: "https://themes.shopify.com/themes/allure/presets/bijou",
          regularPrice: "$100",
          swatch: "bijou",
          readMoreUrl: "https://utdweb.team/shopify-themes/allure",
          startTrialId: "Bijou",
        }),
        createShopifyThemesSliderPreset({
          id: "pristine",
          title: "Pristine",
          imageName: "themes-slider-allure-pristine",
          imageAlt: "Allure Pristine",
          url: "https://themes.shopify.com/themes/allure/presets/pristine",
          regularPrice: "$100",
          swatch: "pristine",
          readMoreUrl: "https://utdweb.team/shopify-themes/allure",
          startTrialId: "Pristine",
        }),
        createShopifyThemesSliderPreset({
          id: "carrara",
          title: "Carrara",
          imageName: "themes-slider-allure-carrara",
          imageAlt: "Allure Carrara",
          url: "https://themes.shopify.com/themes/allure/presets/carrara",
          regularPrice: "$100",
          swatch: "carrara",
          readMoreUrl: "https://utdweb.team/shopify-themes/allure",
          startTrialId: "Carrara",
        }),
        createShopifyThemesSliderPreset({
          id: "stitch",
          title: "Stitch",
          imageName: "themes-slider-allure-stitch",
          imageAlt: "Allure Stitch",
          url: "https://themes.shopify.com/themes/allure/presets/stitch",
          regularPrice: "$100",
          swatch: "stitch",
          readMoreUrl: "https://utdweb.team/shopify-themes/allure",
          startTrialId: "Stitch",
        }),
      ],
    },
    {
      theme: "Gain",
      defaultPresetId: "gain",
      readMore: createShopifyThemesSliderButton({
        text: "Read more",
        href: "https://utdweb.team/shopify-themes/gain/",
      }),
      presets: [
        createShopifyThemesSliderPreset({
          id: "gain",
          title: "Gain",
          imageName: "themes-slider-gain-gain",
          imageAlt: "Gain Theme (Gain)",
          url: "https://themes.shopify.com/themes/gain/presets/gain",
          regularPrice: "$100",
          comparedPrice: "$260",
          swatch: "gain",
        }),
        createShopifyThemesSliderPreset({
          id: "the-lace",
          title: "Lace",
          imageName: "themes-slider-the-lace",
          imageAlt: "Gain Theme (The Lace)",
          url: "https://themes.shopify.com/themes/gain/presets/lace",
          regularPrice: "$100",
          comparedPrice: "$260",
          swatch: "the-lace",
        }),
        createShopifyThemesSliderPreset({
          id: "mio",
          title: "Mio",
          imageName: "themes-slider-mio",
          imageAlt: "Gain Theme (Mio Gallery)",
          url: "https://themes.shopify.com/themes/gain/presets/mio",
          regularPrice: "$100",
          comparedPrice: "$260",
          swatch: "light-pink",
        }),
        createShopifyThemesSliderPreset({
          id: "must-have",
          title: "Sable",
          imageName: "themes-slider-must-have",
          imageAlt: "Gain Theme (Must Have)",
          url: "https://themes.shopify.com/themes/gain/presets/sable",
          regularPrice: "$100",
          comparedPrice: "$260",
          swatch: "must-have",
        }),
        createShopifyThemesSliderPreset({
          id: "maison",
          title: "Maison",
          imageName: "themes-slider-gain-maison",
          imageAlt: "Gain Maison",
          url: "https://themes.shopify.com/themes/gain/presets/maison",
          regularPrice: "$100",
          comparedPrice: "$260",
          swatch: "maison",
        }),
      ],
    },
    {
      disabled: true,
      image: {
        src: `${shopifyThemesSliderImagePath}promotion1x.webp`,
        srcSet: `${shopifyThemesSliderImagePath}promotion1x.webp 1x, ${shopifyThemesSliderImagePath}promotion2x.webp 2x`,
        alt: "Promotion Theme",
      },
      title: "Promotion",
      regularPrice: "$100",
      regularCurrency: shopifyThemesSliderCurrency,
      comparedPrice: "$260",
      comparedCurrency: shopifyThemesSliderCurrency,
      swatchesCount: 3,
      buttons: [
        {
          text: "Read more",
          href: "#",
          target: "_blank",
          variant: "secondary",
        },
        {
          text: "Coming soon",
          href: "#",
          target: "_blank",
          variant: "disabled",
        },
      ],
    },
  ],
}

export const shopifyThemesBenefitsContent = {
  title: "Discover the Advantages of Our Premium Shopify Themes",
  buttonText: "See More",
  items: [
    {
      icon: "mobile",
      title: "Mobile-First & Fully Adaptive",
      text:
        "Our themes are designed with a mobile-first approach, ensuring a seamless shopping experience on any device, enhancing user satisfaction, and boosting sales.",
    },
    {
      icon: "customizable",
      title: "Highly Customizable",
      text:
        "Enjoy completely dynamic templates with over 40 customizable sections, allowing you to precisely tailor your store to your unique brand and stand out from the competition.",
    },
    {
      icon: "speed",
      title: "Fast Loading Speed",
      text:
        "Enhance user experience and reduce bounce rates with our lightning-fast, optimized themes, designed to provide seamless navigation and quick load times across all devices.",
    },
    {
      icon: "seo",
      title: "SEO-Friendly",
      text:
        "Boost your store's visibility with powerful, built-in SEO features that help you rank higher in search results, attracting more customers and driving significantly increased traffic.",
    },
    {
      icon: "ada",
      title: "ADA Compliant",
      text:
        "Make your store accessible to all customers with ADA-compliant themes that meet essential accessibility standards, ensuring a fully inclusive shopping experience.",
    },
    {
      icon: "developer",
      title: "Developer-Free",
      text:
        "Our easy-to-use themes allow you to manage your store without any coding knowledge. Enjoy an unlimited free trial and theme updates to keep your store running smoothly.",
    },
  ],
}

export const shopifyThemesImageWithTextContent = [
  {
    title: "Need help customizing your Theme?",
    description: [
      {
        type: "text",
        text:
          "Ready-made themes are not always the right fit for your brand. With our Premium Support, you will receive a perfectly customized theme that will provide a flawless look and the functionality you need. Whether you need minor adjustments or extensive customization, we will do it all:",
      },
      {
        type: "list",
        items: [
          "Theme customization — customize the theme according to your brand and style requirements.",
          "Content setup – uploading products, images, and text.",
          "Custom features – develop unique elements to boost sales.",
          "Third-party integration — connect Google Tag Manager, Google Analytics, etc.",
          "UX/UI optimization – improve the interface for a perfect user experience.",
        ],
      },
      {
        type: "text",
        text:
          "Enjoy dedicated Premium expert support every step of the way, ensuring your store functions exactly as you expect.",
      },
    ],
    button: {
      text: "Get Premium Support",
      url:
        "https://utdweb.team/contact-us/?utm_source=product_lp&utm_medium=cpa&utm_campaign=customize_premium_theme",
      target: "_blank",
      id: "PremiumSupport",
    },
    image: {
      src: `${shopifyThemesSliderImagePath}teamwork.webp`,
      alt: "Customization themes",
    },
  },
  {
    title: "Starting a new online business or upgrading your web store?",
    description: [
      {
        type: "text",
        text:
          "Standard or even premium themes don't always fit your business needs. Whether you're launching a brand new store or need a custom business logic integration, we'll bring your vision to life with custom design, development, and quality support:",
      },
      {
        type: "list",
        items: [
          "Brand-focused design – a unique look tailored to your brand.",
          "Full-cycle development – from concept to a fully functional store.",
          "SEO-optimized code – clean, structured, and search-friendly.",
          "AA-level accessibility – inclusive and easy to use for all users.",
          "Cross-platform testing – flawless experience on any device.",
          "Launch support – follow every step to ensure a smooth start.",
        ],
      },
      {
        type: "text",
        text:
          "We offer post-launch maintenance as an additional service to keep your store updated and running smoothly. With extensive experience in e-commerce development, we ensure that your project is future-proof, scalable, and set up for success.",
      },
    ],
    button: {
      text: "Free Consultation",
      url:
        "https://utdweb.team/contact-us/?utm_source=product_lp&utm_medium=cpa&utm_campaign=project_from_scratch",
      target: "_blank",
      id: "FreeConsultation",
    },
    image: {
      src: `${shopifyThemesSliderImagePath}business-collaboration.webp`,
      alt: "Premium support",
    },
    isReverse: true,
  },
]

export const shopifyThemesReviewsContent = {
  heading: "What our clients say about our themes",
  totalReviews: "30+ positive reviews",
  video: {
    src:
      "https://www.youtube.com/embed/3XaL2GXOu1I?enablejsapi=1&autoplay=1&mute=1",
    title: "Shopify themes customer review",
    width: 630,
    height: 400,
    poster: {
      src: `${shopifyThemesSliderImagePath}poster1x.webp`,
      srcSet: `${shopifyThemesSliderImagePath}poster1x.webp 1x, ${shopifyThemesSliderImagePath}poster2x.webp 2x`,
      alt: "Poster Image",
    },
  },
  slides: [
    {
      author: "Grafipronto",
      date: "Jul 24, 2024",
      texts: [
        "Super user friendly and the support team is also fast and reliable. Shopify store templates have exceeded my expectations with their modern and responsive design, which is perfect for attracting customers to my online store. I highly recommend these templates to anyone looking to create a professional and user-friendly Shopify store.",
      ],
    },
    {
      author: "FlamesThe Brand",
      date: "Jun 20, 2024",
      texts: [
        "Very nice theme to work with. Fast and great support. Greetings from the Netherlands.",
        "🤩🤩🤩🤩",
      ],
    },
    {
      author: "NamaskaraGuru",
      date: "May 13, 2024",
      texts: [
        "The theme has some good templates, and it's easy to setup the site. Customer care is quite supportive, understands the customer's requirements, and tries to fulfil them.",
      ],
    },
    {
      author: "Doctored Locks",
      date: "May 2, 2024",
      texts: [
        "We absolutely love this theme and UTD has been outstanding to work with. They not only fixed my previous developer's mess, but helped to get our site looking perfect on a tight timeline. I highly recommend UTD and the Gain theme to anyone who needs a well crafted Shopify theme.",
      ],
    },
    {
      author: "Precious Hollows",
      date: "Apr 30, 2024",
      texts: [
        "Coming across this theme we must say that we fell in love with it instantly. If had to place it on a scale we would have to give it a 8/10. The site is very easy to navigate and responsive. though there are some area of concerns and some features that could be polished.",
      ],
    },
    {
      author: "Natural Earth Paint",
      date: "Apr 18, 2024",
      texts: [
        "The theme is well organized and laid out, and the support has been very responsive. They are helping me with a customization.",
      ],
    },
    {
      author: "Noyfer",
      date: "Apr 5, 2024",
      texts: [
        "Awesome theme and support! I've already launch my store with this theme and finally I'm proud of it. The support is great, they respond in less than an hour always with good answers and helping with solutions. Really happy with my theme choice.",
      ],
    },
    {
      author: "Wundersie",
      date: "Apr 4, 2024",
      texts: [
        "Super happy with the Theme and outstanding super helpful support! Thank you!",
        "🤩🤩🤩🤩",
      ],
    },
    {
      author: "Icon Muscle",
      date: "Mar 29, 2024",
      texts: [
        "Beyond impressed with the exceptional level of service UTD provided. Their clear communication and responsiveness make it easy to collaborate and ask questions or concerns that arise.",
      ],
    },
    {
      author: "ALPSCOMMERCE",
      date: "Feb 16, 2024",
      texts: [
        "We use the service very perfectly and great. All the requests resolved very fast and amazing 🤩. The have the technical team can help very quickly and customer support team very helpful. Good",
      ],
    },
    {
      author: "Solgo Atelier",
      date: "Jan 31, 2024",
      texts: [
        "Great theme, easily customizable and excellent support team to help with any potential customization issues.",
        "🤩👍",
      ],
    },
    {
      author: "Foria Wholesale",
      date: "Jan 19, 2024",
      texts: [
        "This theme is easy to use and set up, and it looks beautiful. UTD's customer support is also top-notch. I had an issue with the new B2B features not working as expected, and the UTD team quickly updated their theme to incorporate the new B2B quantity rules to make sure my site worked for our B2B customers.",
      ],
    },
    {
      author: "Cold Off the Press",
      date: "Jan 7, 2024",
      texts: [
        "Barely scratching the surface so far and it's great, only going to get better. Thank you!",
        "😱😱😱",
      ],
    },
    {
      author: "Yana Rozen",
      date: "Dec 18, 2023",
      texts: [
        "Delighted with my UTD theme! User-friendly, beautifully designed, perfect for modern aesthetics. Even as a beginner, navigation was intuitive. Received prompt, professional support despite important questions. Swift, comprehensive responses to all inquiries. Huge thanks to UTD team for excellent work & high-quality product! Highly recommend for convenience, beauty, and exceptional service.",
      ],
    },
    {
      author: "Knightdale Horse Sports",
      date: "Dec 18, 2023",
      texts: [
        "We are very satisfied with our choice of theme - it's very well done, intuitive even for us beginners and complete with everything you need to set up your online shop with a highly professional look. The UTD Support Team has been at our side throughout the customizing process, always open to our requests for personalizing the website and providing prompt solutions and custom codes. Thank you UTD!",
      ],
    },
    {
      author: "Rush Nails",
      date: "Dec 13, 2023",
      texts: [
        "Perfect ! they respond very quickly to help us thank you for this great service. I spent hours searching for the best Shopify templates, and I'm thrilled with the one I finally chose. It offers a perfect balance of aesthetic appeal and functionality, allowing me to showcase my products in the most attractive way possible. The template is not only visually stunning but also highly customizable, which made setting up my store a breeze.",
      ],
    },
    {
      author: "Picture Box Shop",
      date: "Nov 24, 2023",
      texts: [
        "The Theme is absolutely gorgeous and full of great features, it's exceeded my expectations. It has taken my website business to a whole new level of professionalism. The UTD Team have totally blown me away how quickly they've responded and how helpful they've been when I didn't know how to do something. The YouTube videos are excellent too! A beautiful Theme with great support! Highly Recommended!",
      ],
    },
    {
      author: "Teall",
      date: "Nov 22, 2023",
      texts: [
        "The team at UDT have been fantastic to work with. They have been very quick to respond to questions and eager to help. UDT has been open to making changes as we requested them and have also given us great ideas. We strongly recommend UDT. Thank you to everyone who helped us at UDT.",
      ],
    },
    {
      author: "Boshi Botanicals",
      date: "Oct 24, 2023",
      texts: [
        "The customer support has been fantastic in trying to resolve some custom coding issues I had. Their response time was quick and their suggestions and fixes were accurate and thorough. I appreciated the videos walking through what they did so that I could see the process for myself. Highly recommended.",
      ],
    },
    {
      author: "Bluemoonstone Creations",
      date: "Oct 19, 2023",
      texts: [
        "I am so excited and happy with this theme and all the amazing support I have received in helping me set it up. It is literally the best support ever. All of my questions have been answered within a few hours, which has helped me set up my new Shopify site by myself. The theme has everything I need for my jewelry business and allows me to design my new site exactly how I want it. It is perfect!!",
      ],
    },
    {
      author: "Fabric + Flow Textile Co.",
      date: "Oct 16, 2023",
      texts: [
        "Amazing theme with a beatiful look, great features, and even better support. I had a custom feature i wanted, and their devs response time + quality of work was top notch! Thanks UTD for the great theme!",
      ],
    },
    {
      author: "CALI Strong",
      date: "Oct 15, 2023",
      texts: [
        "Fantastic theme with great features. Most importantly, it is fast. Their tech support is outstanding, and responsive. Can't say enough good things about the theme and the developer.",
      ],
    },
    {
      author: "Beau-Fils",
      date: "Oct 9, 2023",
      texts: [
        "This theme is so complete and great, many features are available and that's why I choose this one! Also, the support answered any request that I made within hours! Thanks a lot!",
      ],
    },
    {
      author: "MIRA polewear",
      date: "Oct 4, 2023",
      texts: [
        "Absolutely amazing!! Easy to use, have many design/system options to customize. My store looks gorgeous. Support Team is also quick and very helpful. They respond and solve the issues right away.",
      ],
    },
    {
      author: "LÖV Flowers",
      date: "Sep 27, 2023",
      texts: [
        "Great theme, easy to use and looks really nice! I can confidently say that this is one of the best Shopify templates available, and it has significantly improved the overall look and performance of my online store.",
        "😍😍😍",
      ],
    },
    {
      author: "TCG Corner",
      date: "Sep 27, 2023",
      texts: [
        "Really love this theme and the team is really helpful and fast respond",
        "😍😍😍",
      ],
    },
    {
      author: "SEYANTE",
      date: "Sep 19, 2023",
      texts: [
        "The theme is absolutely amazing. It's very flexible and offers many options. But if you ask me what the best thing about this theme is, I would definitely say it's the support team. The UTD Support Team is simply outstanding. They are always kind, prompt, and attentive to my needs. They don't just provide quick, copy-pasted answers; instead, they delve into the issue and offer tailored solutions.",
      ],
    },
    {
      author: "Intimo modellante snellente contenitivo donna",
      date: "Aug 11, 2023",
      texts: [
        "I finally found the theme that suits my shop. very nice team. I highly recommend.",
        "😱😱😱",
      ],
    },
    {
      author: "Magenta Boutique",
      date: "Jul 24, 2023",
      texts: [
        "This theme is sleek, minimalistic, and beautiful. The support team is incredible and efficient at answering all my questions. This theme is highly reccomended!",
      ],
    },
    {
      author: "beck.bags",
      date: "Jul 20, 2023",
      texts: [
        "We use GAIN as the template for our website. I cannot begin to express my gratitude for this amazing team of professionals. They walk me through every road block I faced! The site looks professional & user flow is exceptional!! I am so happy that I have found this team to work with & I cannot believe that I only paid this price to get this amazing customer service & quality!",
      ],
    },
    {
      author: "Golf Daddy",
      date: "Jul 3, 2023",
      texts: [
        "Gain impresses with its exceptional loading speed, intuitive UX, and vast customizability. A real game-changer in ecommerce, Gain offers seamless navigation and the ability to tailor the theme to your brand, all without compromising performance. Out of all the themes I've bought, Gain tops the list - truly, it's in a league of its own.",
      ],
    },
    {
      author: "Trophy Cupcakes",
      date: "Jul 2, 2023",
      texts: [
        "Transitioned my multi-location bakery to Shopify Plus using Gain. Smooth, packed with features, and built for custom functionality. Programming adheres to the latest Shopify standards. Its speed is a game-changer - significantly faster than other big names. Overall, Gain simplified the entire process, making the site setup way faster and more efficient. This theme is seriously amazing.",
      ],
    },
    {
      author: "Maria e Luisa Jewels",
      date: "Jun 21, 2023",
      texts: [
        "We really liked the theme: it's fast, clean and easy to use. Support was also fantastic: I asked for a customization and in no time at all they replied with a piece of code to add to the theme files. I absolutely recommend it.",
      ],
    },
    {
      author: "Catherine's Boutique",
      date: "Jun 2, 2023",
      texts: [
        "** correction and thank you to customer service for reaching out to me they are doing major updates, visually, this theme is amazing. I would like to move the filter bar location and make sure that larger photos can be viewed on the desktop",
      ],
    },
    {
      author: "CoolLinen",
      date: "May 28, 2023",
      texts: [
        "I was impressed by the variety of elements and sections available in this theme. I didn't require the assistance of a developer to set up and customize my store, which was very convenient and time-saving. However, I encountered a small issue with setting up an additional navigation menu, and I reached out to UTD's support team for help. I must mention that their support was exceptional!",
      ],
    },
    {
      author: "Mae-Lilly",
      date: "May 16, 2023",
      texts: [
        "I downloaded the pretty Gain Theme for my shop and had a few questions. Contacted the theme support team through the website and they were super helpful and quick! They fixed some small issues for me in no time, thanks so much again guys!",
      ],
    },
  ],
}

export const shopifyThemesQuizContent = {
  id: "quiz",
  sendPulse: {
    scriptSrc: "https://static.sppopups.com/assets/loader.js",
    widgetId: "3dc64dea-82aa-4134-b6c8-6933a6dd1cc9",
  },
  antiblockerMessage: [
    "Share your thoughts on missing features for our products.",
    "Disable your AD blocker and take our short QUIZ!",
  ],
  antiblockerImage: {
    src: `${shopifyThemesSliderImagePath}antiblocker.webp`,
    alt: "Anti blocker message",
  },
}
